import { SvgIcon, SvgIconProps } from '@mui/material'

export function PackVariantsIcon(props: SvgIconProps) {
  return (
    <SvgIcon role="img" viewBox="0 0 16 16" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.464 1.011c.158.006.3.011.443.011.43 0 .78.332.78.741 0 .41-.35.741-.78.741-.173 0-.346-.006-.499-.011l-.049-.002a8.432 8.432 0 0 0-.457-.008c-.283.006-.437.042-.533.092-.091.047-.338.221-.43 1.068l2.245.003c1.055.001 1.887.853 1.811 1.853l-.477 6.32c-.107 1.421-1.351 2.523-2.85 2.523H9.15A1.85 1.85 0 0 1 7.722 15H2.818C1.814 15 1 14.226 1 13.27V11.296C1 9.248 2.744 7.59 4.896 7.59h.557L5.27 5.511c-.089-1.01.75-1.876 1.815-1.874l2.29.003c.101-1.16.469-1.96 1.245-2.365.425-.222.88-.267 1.25-.274.188-.004.377.003.547.009l.047.001ZM7.038 7.833c1.463.534 2.502 1.883 2.502 3.462v1.564h2.128c.681 0 1.247-.5 1.296-1.147l.477-6.32a.253.253 0 0 0-.259-.264l-6.1-.009c-.152 0-.272.124-.26.268l.216 2.446ZM5.644 9.071c1.143 0 2.094.78 2.297 1.812H2.6C2.802 9.851 3.753 9.07 4.896 9.07h.748Zm2.337 3.294H2.558v.905c0 .137.117.248.26.248h4.904c.143 0 .26-.111.26-.248v-.905Z"
        fill="currentColor"
      />
    </SvgIcon>
  )
}

export default PackVariantsIcon
